<template>
  <div class="bigBox">
    <div class="detail-tree-item-card">
      <!-- 回放标签-->
      <div
        class="record-icon"
        v-if="treeNode.studyResourceType === 3 && treeNode.resourceList && treeNode.resourceList.length > 0"
      >
        <img src="../../assets/img/components/courseDetail/record_icon.png" alt />
      </div>
      <!-- 直播标签 直播且resourceList存在时显示标签-->
      <div
        class="live-icon"
        v-if="treeNode.studyResourceType === 2 && treeNode.resourceList && treeNode.resourceList.length > 0"
      >直播</div>

      <!-- 考试标签 -->
      <div
        class="record-icon"
        v-if="treeNode.studyResourceType === 7 && treeNode.resourceList && treeNode.resourceList.length > 0"
      >
        <img
          src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/courseDetail/exam_icon.png"
          alt
        />
      </div>
      <!-- title name-->
      <div class="item-title">
        <i v-if="treeNode.name.substr(0,1)=='【'" class="title-special-processing-small" />
        {{ treeNode.name }}
      </div>
      <!-- 展开收起标签-->
      <div
        class="arrow-icon"
        v-if="treeNode.type === 1 && treeNode.children&& treeNode.children.length"
      >
        <template v-if="expand">
          <van-icon name="arrow-up" />
        </template>
        <template v-else>
          <van-icon name="arrow-down" />
        </template>
      </div>
      <!-- 直播时间-->
      <div
        class="live-time"
        v-if="treeNode.studyResourceType === 2 && treeNode.resourceList && treeNode.resourceList.length > 0"
      >{{ initDate(treeNode.resourceList[0].startTime, treeNode.resourceList[0].endTime) }}</div>
    </div>
    <div class="examBottomArea" v-if="treeNode.studyResourceType === 7">
      <div class="examBottomArea_type">考试</div>
      <div class="examBottomArea_line"></div>
      <div class="examBottomArea_time">{{rawExamStr(treeNode.resourceList[0], 'time')}}</div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  props: {
    treeNode: {
      type: Object,
      default: () => ({}),
    },
    expand: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    initDate(start, end) {
      return `${moment(start).format('YYYY.MM.DD HH:mm')}-${moment(end).format('HH:mm')}`;
    },
    rawExamStr(item, type, status) {
      console.log('item', item);
      if (type === 'time') {
        return (
          item.startTime
            .slice(0, 10)
            .split('-')
            .join('.') +
          '-' +
          item.endTime
            .slice(0, 10)
            .split('-')
            .join('.')
        );
      }

      if (type === 'status') {
        var map = {
          '1': '未开始',
          '2': '进行中',
          '3': '已结束',
        };
        console.log('??..??', this.examStatusMap, item.resourceStatus);
        return status == 1 ? '已作答' : map[item.resourceStatus + ''];
      }
    },
  },
};
</script>

<style scoped lang="scss">

.bigBox{
  padding-bottom: 43px;
}
.examBottomArea {
  display: flex;
  align-items: center;
  gap: 14px;
  height: 36px;
  margin-top: 14px;

  .examBottomArea_type {
    /* border: 1px solid #FF6C02; */
    color: #ff6c02;
    padding: 0 15px;
    border-radius: 4px;
    height: 31px;
    font-size: 22px;
    display: flex;
    align-items: center;
    background-color: rgba(255, 182, 129, 0.13);
  }

  .examBottomArea_time {
    height: 36px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 25px;
    color: #999999;
    line-height: 36px;
  }

  .examBottomArea_status {
    height: 36px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 25px;
    color: #999999;
    line-height: 36px;
  }

  .examBottomArea_line {
    width: 2px;
    height: 29px;
    background: #999999;
  }
}
.detail-tree-item-card {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 43px 0 0;

  .record-icon {
    width: 29px;
    height: 29px;
    margin-right: 18px;

    img {
      width: 29px;
      height: 29px;
    }
  }

  .live-icon {
    margin-right: 18px;
    padding: 4px 18px;
    color: $theme_color;
    font-weight: 400;
    font-size: 24px;
    white-space: nowrap;
    border: 1.1px solid $theme_color;
    border-radius: 6px;
  }

  .item-title {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    word-break: keep-all;
  }

  .arrow-icon {
    flex: 1;
    text-align: right;

    i {
      color: #808080;
      font-size: 24px;
    }
  }

  .live-time {
    flex: 1;
    margin-left: 16px;
    line-height: 36px;
    white-space: nowrap;
    text-align: right;
  }

  .tree-node-title {
    font-size: 24px;
    border-bottom: 1.1px solid #f5f5f5;

    .item-title {
      line-height: 36px;
    }
  }

  &.leaf-node {
    .tree-node-title {
      color: #808080;
    }
  }
}

.tree-node-branch {
  &0 {
    .item-title {
      color: black;
      font-weight: bold;
      font-size: 34px;
      line-height: 38px;
    }
  }

  &1 {
    .item-title {
      color: #444;
      font-weight: bold;
      font-size: 28px;
      line-height: 32px;
    }
  }

  &2 {
    .item-title {
      color: #808080;
      font-size: 28px;
      line-height: 32px;
    }
  }
}
</style>
